import { useFormContext } from "react-hook-form";
import NotImplementedWrap from "../../../UniversalEditModal/components/NotImplementedWrap";
import Select from "../../../UI/Select";
import LabeledSelect from "../../../UniversalEditModal/components/LabeledSelect";

export default function ExperienceSelect() {
    const { watch, setValue } = useFormContext();
    const experience = watch("experience");

    return (
        // <NotImplementedWrap>
        <LabeledSelect
            label='Стаж'
            options={Array.from(
                { length: 2026 - 1995 },
                (_, i) => {
                    const y = 1995 + i
                    return { value: y.toString(), label: y.toString()}
                },
            )}
            value={experience}
            setValue={setValue}
            formName="experience"
            classes={{
                select_wrapper: "universaleditmodal-right-content-region",
                select_option: "universaleditmodal-right-content-region-option",
                select_value: "universaleditmodal-right-content-region-value",
            }}
        />
        // {/* </NotImplementedWrap> */}P
    );
}
